import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import { borders } from '@material-ui/system';

import { colors } from '@material-ui/core';

import { shortenAddress, useEthers } from '@usedapp/core';
import { constants, utils, BigNumber } from "ethers";


import { useGetTop3Depositors, useGetTop3Referrers, useViewUserInfo } from '../../hooks/nodes/nodeHooks.jsx';




const useStyles = makeStyles((theme) => {
    const btnColor = "rgb(50,50,50)"

    return {
      container: {
        background: "linear-gradient(0deg, #151332 0%, rgba(21, 19, 50, 0) 100%), linear-gradient(282.66deg, rgba(42, 179, 255, 0.19) -6.68%, rgba(117, 32, 255, 0.19) 51.39%, rgba(255, 66, 179, 0.19) 106.96%), #151332",
          padding: theme.spacing(4, 8, 6),
      },
      whiteText: {
        color: "#ffffff"
      },
      goldText: {
        color: "#ffe699"
      },
      greyText: {
        color: "#a6a6a6"
      },
      blueText: {
        color: "#6febeb"
      },
      greenText: {
        color: "#50C878"
      },
      purpleText: {
        color: "rgb(164, 168, 255)"
      },
      secondaryText: {
        color: "rgb(164, 158, 189)"
      },
      boxCard: {
        padding: theme.spacing(2, 3, 2),
        minWidth: "16rem",
        backgroundColor: "rgb(40,40,40)"
      },
      stakingCard: {
        backgroundColor: "rgb(40,40,40)",
        minWidth: "20rem",
      },
      btnColor: {
        color: "#ffe699",
        backgroundColor: btnColor,
        "&:hover": {
            color: "rgb(50,50,50)",
            backgroundColor:" #ffe699",
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: btnColor
          }
        }
      },
      textField: {
            borderColor: '#ffe699'
        },
        
      divider: {
        backgroundColor: "#ffe699",
        minHeight: "0.12rem"
      },
      notchedOutline: {
        borderColor: "#a6a6a6 !important",
      },
      textFieldColorRef: {
        color: "#a6a6a6 !important",
        fontWeight: "bold",
        fontSize:"1rem",
      },
      leaderboard: {
        background: "linear-gradient(282.66deg, rgba(42, 179, 255, 0.19) -6.68%, rgba(117, 32, 255, 0.19) 51.39%, rgba(255, 66, 179, 0.19) 106.96%), linear-gradient(0deg, #151332 0%, rgba(21, 19, 50, 0) 100%), #151332",
        padding: theme.spacing(2, 3, 2),
        // minWidth: "16rem"
      },
      winner: {
        backgroundColor: "rgb(164, 168, 255)",
        // background: "linear-gradient(to right, #4568dc, #b06ab3)",
        color: "black"
      }
    }
});

function NodeVault() {
    const classes = useStyles();

    let { account } = useEthers();

    const topThreeDepositors = useGetTop3Depositors();
    const topThreeReferrers = useGetTop3Referrers();
    const userInfo = useViewUserInfo(0);


    if (account) {
      account = shortenAddress(account);
    }


    return (
        <div className={ classes.container }>
            <Grid container spacing={8} direction="column" >
                <Grid container item>
                  <Grid container direction='column' alignItems='center'>
                    <Grid item>
                          <Typography className={classes.purpleText} variant='h3'>
                              <strong>NODE VAULT REWARDS</strong> 
                          </Typography>
                      </Grid>
                      
                      <Grid item>
                          <Typography className={classes.secondaryText} variant='h6'>
                              <strong>Win up to 4% of the TVL (Total Value Locked) on a weekly basis</strong> 
                          </Typography>
                      </Grid>

                  </Grid>
                    
                </Grid>

                <Grid container item>
                  <Grid container direction='row' justifyContent='space-evenly' spacing={5}>
                    <Grid container item md={6}>
                  
                      <Grid className={ classes.leaderboard } container direction="column" spacing={2}>
                        <Grid item>
                          <Typography className={ classes.purpleText } variant="h4" align="center">
                            <strong>TOP DEPOSITOR</strong>
                          </Typography>
                          <Typography className={ classes.secondaryText } variant="body1" align="center">
                            The top weekly depositor wins 2% of the TVL
                          </Typography>
                        </Grid>
                        {topThreeDepositors.map((d, i) => (
                          <Grid className={ i === 0 ? classes.winner : classes.whiteText } item container key={d.name}>
                            <Grid item xs={5}>
                              <Typography variant="body1" align="left">
                                {i + 1}. {d.address}
                              </Typography>
                            </Grid>
                            <Grid item xs={7}>
                              <Typography variant="body1" align="right">
                                {d.deposit}
                              </Typography>
                            </Grid>
                          </Grid>
                        ))}
                        
                        
                        <Grid item >
                          <Typography className={ classes.whiteText } variant="body1" align="center">
                            Your weekly deposit: {userInfo ? parseFloat(utils.formatEther(userInfo[4])).toFixed(2) : 0}
                          </Typography>
                        </Grid>
                        
                        {account == topThreeDepositors[0].address && (
                          <Typography className={ classes.greenText } variant="body2" align="center">
                            <strong>You are the top depositor.</strong> 
                          </Typography>
                        )}

                        {account != topThreeDepositors[0].address && (
                          <Typography className={ classes.secondaryText } variant="body2" align="center">
                            You are not the top depositor
                          </Typography>
                        )}
                        
                      </Grid>
                    
                    </Grid>

                    <Grid container item md={6}>
                  
                      <Grid className={ classes.leaderboard } container direction="column" spacing={2}>
                        <Grid item>
                          <Typography className={ classes.purpleText } variant="h4" align="center">
                            <strong>TOP REFERRER</strong>
                          </Typography>
                          <Typography className={ classes.secondaryText } variant="body1" align="center">
                            The top weekly referrer wins 2% of the TVL
                          </Typography>
                        </Grid>
                        {topThreeReferrers.map((d, i) => (
                          <Grid className={ i === 0 ? classes.winner : classes.whiteText } item container key={d.name}>
                            <Grid item xs={5}>
                              <Typography variant="body1" align="left">
                                {i + 1}. {d.address}
                              </Typography>
                            </Grid>
                            <Grid item xs={7}>
                              <Typography variant="body1" align="right">
                                {d.deposit}
                              </Typography>
                            </Grid>
                          </Grid>
                        ))}
                        
                        
                        <Grid item >
                          <Typography className={ classes.whiteText } variant="body1" align="center">
                            Your weekly referrals: {userInfo ? parseFloat(utils.formatEther(userInfo[5])).toFixed(2) : 0}
                          </Typography>
                        </Grid>
                        
                        {account == topThreeReferrers[0].address && (
                          <Typography className={ classes.greenText } variant="body2" align="center">
                            <strong>You are the top referrer.</strong> 
                          </Typography>
                        )}

                        {account != topThreeReferrers[0].address && (
                          <Typography className={ classes.secondaryText } variant="body2" align="center">
                            You are not the top referrer
                          </Typography>
                        )}
                        
                      </Grid>
                    
                    </Grid>


                  </Grid>

                </Grid>

                <Grid item>
                  <Typography className={ classes.purpleText } variant="h4" align="center">
                    <strong>NEXT WINNERS PICKED ON:</strong>
                  </Typography>

                </Grid>
                
            </Grid>
        </div>    
    );
  }
  
export default NodeVault;